<template>
  <div class="shenyunjie-chart-thermometer-h" :id="id"></div>
</template>

<script>
import Highcharts from "highcharts/highstock";
import DarkUnica from "../../theme/charts/highcharts-dark-unica.js";
import merge from "deepmerge";

export default {
  name: "YunJieChartThermometerH",
  props: {
    id: {
      type: String,
      default: function () {
        return new Date().getTime() + "-" + Math.ceil(Math.random() * 1000);
      }
    },
    loadChart: {
      type: Boolean,
      default: true
    },
    theme: {
      type: String,
      default: ""
    },
    pattern: {
      type: String,
      default: "temperature"
    },
    value: {
      type: Number,
      default: 0
    },
    changeColour: {
      type: Boolean,
      default: true
    },
    size: {
      type: Boolean,
      default: true
    },
    option: {
      type: Object,
      default: function () {
        return {}
      }
    },
    updateOption: {
      type: Function,
      default: null
    }
  },
  components: {},
  data() {
    return {
      chart: null,
      defaultOption: {
        accessibility: {
          enabled: false
        },
        credits: {
          enabled: false
        },
        title: {
          style: {
            color: "#5470C6",
            fontWeight: "bold"
          }
        },
        tooltip: {
          enabled: false
        },
        legend: {
          enabled: false
        },
        yAxis: [{
          visible: false,
          min: 0,
          max: 180,
          endOnTick: false,
          tickInterval: 10
        }, {
          min: 0,
          max: 180,
          endOnTick: false,
          title: {
            enabled: false
          },
          gridLineWidth: 0,
          tickColor: "rgb(102, 102, 102)",
          tickWidth: 1,
          minorGridLineWidth: 0,
          minorTickColor: "rgb(102, 102, 102)",
          minorTickWidth: 1,
          minorTickLength: 4,
          labels: {},
          endOnTick: true
        }],
        xAxis: {
          visible: false
        },
        plotOptions: {
          column: {
            animation: false,
            borderWidth: 0,
            shadow: false,
            grouping: false,
            pointPlacement: 0
          },
          scatter: {
            animation: false,
            marker: {
              symbol: "circle"
            }
          },
          series: {
            states: {
              hover: {
                enabled: false
              },
              inactive: {
                opacity: 1
              }
            }
          }
        },
        series: [{
          type: "column",
          name: "数据条",
          data: [0],
          dataLabels: {
            enabled: true
          },
          color: {
            linearGradient: {
              x1: 0,
              y1: 1,
              x2: 0,
              y2: 0
            }
          },
          zIndex: 2
        }, {
          type: "column",
          name: "白框",
          data: [178],
          color: "#0C2E6D",
          zIndex: 1
        }, {
          type: "column",
          name: "外框",
          data: [180],
          color: "#4577BA",
          zIndex: 0
        }, {
          type: "scatter",
          name: "圆",
          data: [0],
          color: "#93FE94",
          marker: {},
          zIndex: 2
        }, {
          type: "scatter",
          name: "白圆",
          data: [0],
          color: "#0C2E6D",
          marker: {},
          zIndex: 1
        }, {
          type: "scatter",
          name: "外圆",
          data: [0],
          color: "#4577BA",
          marker: {},
          zIndex: 0
        }]
      },
      resizeObserver: null
    };
  },
  mounted() {
    let self = this;
    // 元素大小变化监听
    self.resizeObserver = new ResizeObserver((entries) => {
      if (self.chart) {
        self.chart.destroy();
        this.chart = null;
      }
      self.init();
    });
    self.resizeObserver.observe(document.getElementById(self.id));
    if (self.loadChart) {
      self.init();
    }
  },
  methods: {
    init() {
      let self = this;
      // 页面已存在
      if (document.getElementById(self.id) && document.getElementById(self.id).offsetHeight > 0) {
        // 合并主题
        let theme = self.theme || (this.$YunJie || {}).theme || "standard";
        let opt = merge({}, self.defaultOption);
        if (theme == "darkness") {
          let _DarkUnica = merge({}, DarkUnica);
          let _yAxis = _DarkUnica.yAxis;
          delete _DarkUnica.yAxis;
          opt = merge(opt, _DarkUnica);
          opt.yAxis[0] = merge(opt.yAxis[0], _yAxis);
          opt.yAxis[1] = merge(opt.yAxis[1], _yAxis);
        }
        // 配置汇总
        let parameter = {
          title: {
            text: self.size ? (self.pattern == "temperature" ? "温度" : "湿度") : null
          },
          chart: {
            marginTop: self.size ? 32 : 2,
            marginBottom: self.size ? 36 : 16,
            marginLeft: 0,
            marginRight: 0
          }
        };
        opt = merge(opt, parameter);
        // 刻度
        let LabelFormatter = null;
        // 中间线的渐变色和文本内容
        let Gradient = [];
        if (self.pattern == "temperature") {
          LabelFormatter = function () {
            let v = this.value - 50;
            return v >= -40 && v <= 120 ? v : "";
          }
          opt.yAxis[1].tickPositions = [0, 10, 30, 50, 70, 90, 110, 130, 150, 170, 180];
          opt.yAxis[1].minorTickInterval = 5;
          opt.yAxis[1].className = "yunjie-highcharts-graduation-temperature";
          opt.series[0].data[0] = Math.max(Math.min(self.value + 50, 170), 0);
          if (self.value > 40) {
            Gradient = [
              [0.15, "#93FE94"],
              [0.5, "#E4D225"],
              [1, "#E01F28"]
            ];
          } else if (self.value >= 15) {
            Gradient = [
              [0.15, "#93FE94"],
              [1, "#E4D225"]
            ];
          } else {
            Gradient = [
              [1, "#93FE94"]
            ];
          }
        } else {
          LabelFormatter = function () {
            let v = (this.value - 20) / 1.5;
            return v >= 0 && v <= 100 ? v : "";
          }
          opt.yAxis[1].tickPositions = [0, 20, 50, 80, 110, 140, 170, 180];
          opt.yAxis[1].minorTickInterval = 10;
          opt.yAxis[1].className = "yunjie-highcharts-graduation-humidity";
          opt.series[0].data[0] = Math.max(Math.min((self.value * 1.5 + 20), 170), 0);
          if (self.value > 80) {
            Gradient = [
              [0.15, "#93FE94"],
              [0.5, "#E4D225"],
              [1, "#E01F28"]
            ];
          } else if (self.value >= 40) {
            Gradient = [
              [0.15, "#93FE94"],
              [1, "#E4D225"]
            ];
          } else {
            Gradient = [
              [1, "#93FE94"]
            ];
          }
        }
        let valueColor = Gradient[Gradient.length - 1][1];
        opt.yAxis[1].labels.formatter = LabelFormatter;
        opt.series[0].color.stops = self.changeColour ? Gradient : [[1, "#93FE94"]];
        opt.series[0].dataLabels.color = self.changeColour ? valueColor : "#93FE94";
        opt.series[0].dataLabels.formatter = function () {
          return `${self.value}${self.pattern == "temperature" ? "°C" : "%"}`;
        };
        opt.series[0].maxPointWidth = self.size ? 18 : 6;
        opt.series[1].maxPointWidth = self.size ? 18 : 6;
        opt.series[1].borderRadius = self.size ? 9 : 3;
        opt.series[2].maxPointWidth = self.size ? 28 : 14;
        opt.series[2].borderRadius = self.size ? 14 : 7;
        opt.series[3].marker.radius = self.size ? 19 : 6;
        opt.series[4].marker.radius = self.size ? 25 : 10;
        opt.series[5].marker.radius = self.size ? 30 : 14;
        if (self.size) {
          opt.yAxis[1].visible = true;
          let width = document.getElementById(self.id).offsetWidth;
          opt.yAxis[1].offset = -width / 2 + 18;
        } else {
          opt.yAxis[1].visible = false;
        }
        // 合并自定义配置
        opt = merge(opt, self.option);
        // 用户自定义属性
        if (self.updateOption) {
          opt = self.updateOption(opt);
        }
        if (!self.chart) {
          self.chart = Highcharts.chart(self.id, opt);
        } else {
          self.chart.update(opt);
        }
      }
    }
  },
  destroyed() {
    this.resizeObserver.disconnect();
  },
  watch: {
    theme() {
      // 销毁已有曲线
      if (this.chart) {
        this.chart.destroy();
        this.chart = null;
      }
      this.init();
    },
    pattern() {
      this.init();
    },
    value() {
      this.init();
    },
    changeColour() {
      this.init();
    },
    size() {
      // 销毁已有曲线
      if (this.chart) {
        this.chart.destroy();
        this.chart = null;
      }
      this.init();
    },
    option: {
      deep: true,
      handler(option) {
        this.init();
      }
    }
  }
}
</script>

<style lang="scss">
.shenyunjie-chart-thermometer-h {
  .highcharts-yaxis.yunjie-highcharts-graduation-temperature {
    :nth-last-of-type(2) {
      display: none;
    }

    :nth-last-of-type(12) {
      display: none;
    }

    :nth-last-of-type(13) {
      display: none;
    }

    :nth-last-of-type(14) {
      display: none;
    }
  }

  .highcharts-yaxis.yunjie-highcharts-graduation-humidity {
    :nth-last-of-type(2) {
      display: none;
    }

    :nth-last-of-type(9) {
      display: none;
    }

    :nth-last-of-type(10) {
      display: none;
    }

    :nth-last-of-type(27) {
      display: none;
    }

    :nth-last-of-type(28) {
      display: none;
    }
  }
}
</style>

<style lang="scss" scoped>
.shenyunjie-chart-thermometer-h {
  height: 100%;
  width: 100%;
}
</style>


// WEBPACK FOOTER //
// src/components/charts/thermometerH.vue